export enum FlowchartDirection {
  TopToBottom = 'TB',
  BottomToTop = 'BT',
  LeftToRight = 'LR',
  RightToLeft = 'RL',
}

export enum FlowchartNodeShape {
  Terminator = 'terminator',
  Process = 'process',
  Decision = 'decision',
  InputOutput = 'inputOutput',
  Connector = 'connector',
  Document = 'document',
  Database = 'database',
  PredefinedProcess = 'predefinedProcess',
  Hexagon = 'hexagon',
  Trapezoid = 'trapezoid',
}

export enum FlowchartNodeRole {
  Start = 'start',
  End = 'end',
  None = 'none',
}

export enum FlowchartEdgeKind {
  Arrow = 'arrow',
  Dotted = 'dotted',
  Thick = 'thick',
  Open = 'open',
}

export enum FlowchartMarkerKind {
  None = 'none',
  Arrow = 'arrow',
  Circle = 'circle',
  Cross = 'cross',
}

export enum FlowchartLabelOrigin {
  ExplicitLabel = 'explicitLabel',
  BareDeclaration = 'bareDeclaration',
  ImplicitEdgeRef = 'implicitEdgeRef',
  SubgraphRef = 'subgraphRef',
  Unresolved = 'unresolved',
}

export interface FlowchartNodeStyle {
  fill?: string;
  stroke?: string;
  color?: string;
  strokeWidth?: string;
}

export interface FlowchartSubgraph {
  id: string;
  label: string | null;
  parent: string | null;
  classNames: string[];
  inlineStyle: FlowchartNodeStyle | null;
}

export interface FlowchartNode {
  id: string;
  label: string | null;
  labelOrigin: FlowchartLabelOrigin;
  shape: FlowchartNodeShape | null;
  parent: string | null;
  classNames: string[];
  inlineStyle: FlowchartNodeStyle | null;
}

export interface FlowchartEdge {
  id: string;
  edgeId: string | null;
  from: string;
  to: string;
  label: string | null;
  kind: FlowchartEdgeKind;
  startMarker: FlowchartMarkerKind;
  endMarker: FlowchartMarkerKind;
  classNames: string[];
}

export interface ParsedFlowchart {
  direction: FlowchartDirection;
  nodes: FlowchartNode[];
  edges: FlowchartEdge[];
  subgraphs: FlowchartSubgraph[];
  classDefs: Map<string, FlowchartNodeStyle>;
  unsupportedDirectives: string[];
}
